import { GetCulpritCustomerImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImagesTabs/getCulpritCustomerImagesTabs.type';
import { getCulpritCustomerImagesTabsQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImagesTabs/getCulpritCustomerImagesTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritCustomerImagesTabsOptions = (
  params: GetCulpritCustomerImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_CUSTOMER_Culprit_IMAGE_TABS', params],
    queryFn: () => getCulpritCustomerImagesTabsQueryFunction(params),
  });
};
